import T from '@wojtekmaj/react-t';

import LinkButton from '@rewardopl/react-ui/link_button';

import { ContentWrapper, Image, PageWrapper, Sub, Title } from './index.styles';

import RewardoLogo from '../../common/rewardo_logo';

import { SHOULD_DISABLE_REGISTER_PAGE } from '../../../constants';

import padlockIcon from '../../../static/padlock.svg';

type NoAccessPageProps = {
  state?: object;
};

export default function NoAccessPage({ state }: NoAccessPageProps) {
  return (
    <PageWrapper>
      <ContentWrapper>
        <RewardoLogo width={164} />
        <Image width={124} height={124} src={padlockIcon} alt="" />
        <Title>
          <T>No access</T>
        </Title>
        <Sub>
          <T>This page is for logged in users only.</T>
        </Sub>
        <p>
          <LinkButton className="primary" to="/login" state={state}>
            <T>Login</T>
          </LinkButton>
        </p>
        {SHOULD_DISABLE_REGISTER_PAGE ? null : (
          <p>
            <LinkButton to="/register" state={state}>
              <T>Register</T>
            </LinkButton>
          </p>
        )}
      </ContentWrapper>
    </PageWrapper>
  );
}
